import { defineStore } from 'pinia';
import { MailerRepo } from '@fibl/zdb-common';
import { useTokenStore } from './token';

export const useMailerStore = defineStore('mailerStore', {

	state: () => ({
		mailResults: [] as { email: string; status: string; expired: boolean }[],
		mailsForNotification: [] as string[],
		showVerificationDialog: false,
		isVerficationDialogShown: false
	}),

	persist: {
		paths: ['mailResults'],
		afterRestore: (ctx) => {
			ctx.store.mailResults = ctx.store.mailResults.filter(
				(r: { email: string; status: string; expired: boolean }) => r.status === 'verified',
			);
		},
	},

	getters: {
		needsEmailVerification(): boolean {
			return this.mailsForNotification.length === 0
				|| this.mailsForNotification.some(e => !this.mailResults.some(r => r.email === e && r.status === 'verified'))
		}
	},

	actions: {
		statusForMail(id: string) {
			const index = this.mailResults.findIndex((r) => r.email === id);
			if (index === -1) {
				return 'open';
			}
			const status = this.mailResults[index].status;
			if (typeof status === 'boolean' && status === true) {
				return 'verified';
			}
			return status;
		},
		expiredForMail(id: string): boolean {
			const index = this.mailResults.findIndex((r) => r.email === id);
			if (index === -1) {
				return true;
			}
			return this.mailResults[index].expired;
		},
		async getMailStatus(email: string) {
			const index = this.mailResults.findIndex((r) => r.email === email);
			if (index === -1) {
				const data = await MailerRepo.getEmailVerificationStatus(email);
				this.mailResults.push({ email: email, status: data.status, expired: data.expired });
				// console.log('getMailStatus', email, data.status, 'fresh');
				return data.status;
			}
			// console.log('getMailStatus', email, this.mailResults[index].status, 'cached');
			return this.mailResults[index].status;
		},
		async loadAllEmails(emails: string[]) {
			for (let id of emails) {
				await this.getMailStatus(id);
			}
		},
		setVerificationStatus(email: string, status: string, expired: boolean) {
			const index = this.mailResults.findIndex((r) => r.email === email);
			if (index === -1) {
				this.mailResults.push({ email: email, status: status, expired: expired });
			} else {
				this.mailResults[index] = { ...this.mailResults[index], status, expired };
			}
		},
		async requestVerification(data: { email: string; language: string }) {
			let success = await MailerRepo.requestVerification(data);
			if (success) this.setVerificationStatus(data.email, 'pending', false);
		},
		async completeVerification(email: string, code: string) {
			let success = await MailerRepo.completeVerification({ email, code, accepted: true });
			if (success) this.setVerificationStatus(email, 'verified', false);
		},
		async userAutoVerification() {
			const tokenStore = useTokenStore();
			const accountModel = tokenStore.getAccountModel();
			const sso = tokenStore.sso;
			const mails = accountModel.getEmailForNotification();
			if (mails?.length === 0 && !mails.includes(sso.parsed.email) && !tokenStore.main.details.userData.noEmailVerification) {
				mails.push(sso.parsed.email);
			}
			console.log('userAutoVerification', mails);
			for (let mail of mails) {
				let status = this.mailResults.find(e => e.email === mail)?.status;
				if (!status) {
					status = await this.getMailStatus(mail);
				}
				try {
					if (mail === sso.parsed.email && status !== 'verified' && sso.parsed.email_verified) {
						await MailerRepo.ssoVerification({ token: tokenStore.sso.accessToken });
						this.setVerificationStatus(
							mail,
							'verified',
							false,
						);
						console.log('mail sso verified', mail);
					}
				} catch (err) {
					console.error('error verifying from sso token', err);
				}
			}
			this.mailsForNotification = mails;
		}
	},
});
